var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{staticStyle:{"top":"5%","height":"90%"},attrs:{"title":"绑定模板","width":"80%","visible":_vm.visible,"maskStyle":{'top':'93px','left':'154px'},"maskClosable":false,"cancelText":"取消","okText":"保存"},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('templateList',{ref:"templatelist",attrs:{"choose":true,"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }